import React from 'react'
import SelectInput from './SelectInput'
import {
  useSelector
} from 'react-redux'
import {
  sort_name
} from '../../../Functions/Sort'
import {
  get_user_long
} from '../../../Functions/Strings'

const SelectSalarie = (props) => {
  const equipe = useSelector(state => state.equipe.equipe)
  const team = equipe.filter(item => item.archive === 0)
  return (
    <SelectInput
      label="Salarié"
      options={sort_name(team).map(item => {
        return {
          value: item.id,
          label: get_user_long(item)
        }
      })}
      {...props}
    />
  )
}

export default SelectSalarie
